// @ts-nocheck
import { merge } from '../../helper';

import * as exModal from '../../components/modal';
import * as exElement from '../element';

import * as video from './video';

// ----------------------------------------------------------------------------

function create(config = {}): any {
    // Default Config
    const defConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (canvas)
    const elCanvas = exElement.create({
        merge: defConfig,
        tag: 'canvas',
    });

    // ------------------------------------------------------------------------

    // Settings
    settings(elCanvas, defConfig);

    // Return
    return elCanvas;
}

function settings(element, config = {}): any {
    /* const context = element.getContext('2d'); */

    // If using video
    if (config.video) {
        // Create element (video)
        video.create(element, config.video);
    }

    // If using modal
    if (config.modal) {
        // Create element (modal)
        const modal = exModal.create({
            merge: config.modal,
            backdrop: 'static',
            destroy: true,
        });
        modal.child(element).showModal();
    }
}

export { create };
